import Invoice from './InvoiceDetail/Invoice';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SignInvoice from './SignInvoice/SignInvoice';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CheckList from './CheckList/CheckList';
import AllCheckList from './AllChecklist/AllChecklist';
import AppPayment from './AppPayment/AppPayment';
import Quote from './QuoteDetail/Quote';
import SalesQuote from './QuoteDetail/SalesQuote';
import AllEquipmentTaskListPage from './InvoiceDetail/AllEquipmentTaskListPage';
import WorkOrderDetails from './WorkOrderDetails/WorkOrderDetails';

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route index element={<Invoice isPayment={false} />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/salesquote" element={<SalesQuote />} />
          <Route path="/signInvoice" element={<SignInvoice />} />
          <Route path="/checklist" element={<CheckList isEdit={true} />} />
          <Route path="/all-checklist" element={<AllCheckList />} />
          <Route path="/tasklist" element={<CheckList isEdit={false} />} />
          <Route path="/app-payment" element={<AppPayment />} />
          <Route path="/app-payment-status" element={<AppPayment />} />
          <Route path="/all-equipment-tasklist" element={<AllEquipmentTaskListPage />} />
          <Route path="/receipt" element={<Invoice isPayment={false} isReceipt={true} />} />
          <Route path="/WorkOrderDetails" element={<WorkOrderDetails />} />
          <Route path="*" element={<Invoice isPayment={false} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
